/* assets/faq-kimono-plage.js */
(function () {
  function initFaq() {
    const root = document.getElementById('faq-kimono');
    if (!root) return;

    const allDetails = Array.from(root.querySelectorAll('details'));

    // Accessibilité de base
    root.querySelectorAll('details > summary').forEach((s) => {
      s.setAttribute('role', 'button');
      s.setAttribute('tabindex', '0');
      const d = s.parentNode;
      s.setAttribute('aria-expanded', String(!!d.open));

      s.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          s.click();
        }
      });
    });

    // Délégation + phase de capture : passe AVANT les listeners du thème
    document.addEventListener(
      'click',
      (e) => {
        const summary = e.target.closest('#faq-kimono summary');
        if (!summary) return;

        // Neutralise tout handler qui bloquerait le toggle
        e.preventDefault();
        e.stopPropagation();

        const current = summary.parentNode; // <details>
        const willOpen = !current.open;

        // Mode accordéon : ferme les autres
        allDetails.forEach((d) => {
          if (d !== current) {
            d.open = false;
            const s = d.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });

        // Ouvre/ferme celui cliqué
        current.open = willOpen;
        summary.setAttribute('aria-expanded', String(current.open));
      },
      true // <— capture !
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
